import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import EditorJSSingle from "../../../components/admin/usable/EditorJSSingle";
import Checkbox from "@mui/joy/Checkbox";
import AddButton from "../../../components/admin/usable/AddButton";
import { addBlog, viewBlogCategory } from "../../../api/admin/blogApi";
import {
  setForAll,
  setIsSingleSelected,
  setShowFileUploader,
  setSingleSelected,
} from "../../../redux/admin/fileManagerSlice";
import FileUploadandSelect from "../../../components/admin/usable/fileuploader/FileUploadandSelect";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const CreateBlog = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState("");
  const [Tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [CategoryData, setCategoryData] = useState([]);
  const { showFileUploader, singleSelected } = useSelector(
    (state) => state.file,
  );
  const [FormData, setFormData] = useState({
    blogTitle: "",
    body: "",
    featuredImage: "",
    categoryId: "",
    tags: [],
    status: "Draft",
    created_by: "",
    createdAt: new Date().toISOString(),
  });
  const dispatch = useDispatch();

  const handleAddTags = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const value = inputValue.trim();
      if (value && !Tags.includes(value)) {
        setTags([...Tags, value]);
      }
      setInputValue("");
    }
  };
  const handleDeleteTag = (tag) => {
    const updatedTags = Tags.filter((t) => t !== tag);
    setTags(updatedTags);
  };
  useEffect(() => {
    viewBlogCategory(setCategoryData);
    dispatch(setForAll(true));
    dispatch(setIsSingleSelected(true));
    setFormData((prevData) => ({
      ...prevData,
      featuredImage: singleSelected?.fileLink?.medium || "",
      tags: Tags,
      body: content,
    }));

    return () => {
      dispatch(setForAll(false));
      dispatch(setIsSingleSelected(false));
    };
  }, [dispatch, singleSelected, Tags, content]);
  const handleShowFileManager = () => {
    dispatch(setShowFileUploader(true));
    dispatch(setForAll(true));
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  const handleSubmit = () => {
    if (
      FormData.blogTitle === "" ||
      FormData.body === "" ||
      FormData.categoryId === "" ||
      FormData.featuredImage === ""
    ) {
      toast.error("Please fill all the required fields");
    } else {
      addBlog(FormData, setFormData, navigate);
    }
  };
  return (
    <>
      {showFileUploader && <FileUploadandSelect />}
      <div className="w-full space-y-5">
        <div className="flex justify-between items-center">
          <p className="font-bold text-black text-lg">Create A Post</p>
          <AddButton onClick={handleSubmit} text="Add Post" />
        </div>
        <div className="flex lg:flex-row flex-col gap-3">
          <div className="flex-1 border drop-shadow p-3 bg-white rounded-lg">
            <div>
              <input
                type="text"
                className="w-full px-4 py-3 rounded-lg border focus:outline-none mb-3"
                placeholder="Write a blog title..."
                id="blogTitle"
                value={FormData.blogTitle}
                onChange={handleChange}
              />
            </div>
            <div>
              <EditorJSSingle content={content} setContent={setContent} />
            </div>
          </div>
          <div className="w-full lg:w-[300px] border drop-shadow p-3 bg-white rounded-lg space-y-5">
            <div>
              <label>Status</label>
              <select
                className="w-full px-4 py-2 rounded-lg border focus:outline-none mb-3"
                id="status"
                value={FormData.status}
                onChange={handleChange}
              >
                <option value="Draft">Draft</option>
                <option value="Published">Published</option>
                <option value="Unpublished">Unpublished</option>
              </select>
            </div>
            <div>
              <label>Featured Image</label>
              <div className="relative">
                <img
                  className="w-full h-40 object-cover rounded-lg"
                  src={
                    FormData.featuredImage
                      ? FormData.featuredImage
                      : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                  }
                  alt=""
                />
                <div
                  onClick={handleShowFileManager}
                  className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg"
                >
                  <p className="font-bold">Upload Now</p>
                </div>
              </div>
            </div>
            <div>
              <label>Categories</label>
              <div className="w-full h-auto p-2 bg-black/5 rounded-lg">
                {CategoryData.map((item, index) => {
                  const isChecked = FormData.categoryId === item.id;

                  return (
                    <div key={index}>
                      <Checkbox
                        id="category"
                        label={item.category_name}
                        size="sm"
                        checked={isChecked}
                        onChange={() => {
                          setFormData((prev) => ({
                            ...prev,
                            categoryId: item.id, // just pass the id
                          }));
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>

            <div>
              <label>Tags</label>
              <div className="w-full h-auto p-2 rounded-lg flex flex-wrap gap-2">
                <input
                  type="text"
                  className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                  placeholder="Enter tags..."
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyDown={handleAddTags}
                />
                {Tags.map((tag, index) => (
                  <>
                    <div
                      onClick={() => handleDeleteTag(tag)}
                      key={index}
                      className="px-3 py-1 bg-black/10 rounded-full text-xs flex items-center gap-2 cursor-pointer"
                    >
                      {tag}
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateBlog;
